import { Component, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { AccountService } from 'src/app/services/account.service';
import { Profile } from 'src/app/services/bdoservice/users/models/profile.model';
import { AccountType } from 'src/app/services/bdoservice/users/users.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  standalone: false
})
export class ProfileComponent {

  private readonly accountService = inject(AccountService);

  profile$: Observable<Profile | null> = this.accountService.profile$.pipe(
    map(res => res?.data)
  );

  loading$: Observable<boolean> = this.accountService.profile$.pipe(
    map(res => res?.loading || false)
  );

  hasError$: Observable<boolean> = this.accountService.profile$.pipe(
    map(res => !!res?.error)
  );

  getAccountType(): AccountType {
    return this.accountService.getAccountType();
  }

  retry(): void {
    this.accountService.loadProfile();
  }
}
